module.exports = __webpack_public_path__ + "img/color_purple.c5b3efb2.svg";